/**
 * Reusable Badge component with dark theme
 */

import React, { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Badge({ 
  children, 
  variant = 'default', 
  size = 'md',
  className = '' 
}: BadgeProps) {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';

  const variantClasses = {
    default: 'bg-gray-700 text-gray-200',
    primary: 'bg-blue-900 text-blue-200 border border-blue-700',
    success: 'bg-green-900 text-green-200 border border-green-700',
    warning: 'bg-yellow-900 text-yellow-200 border border-yellow-700',
    danger: 'bg-red-900 text-red-200 border border-red-700',
    info: 'bg-cyan-900 text-cyan-200 border border-cyan-700',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <span className={classes}>
      {children}
    </span>
  );
}